export default __webpack_public_path__ + "static/media/move.32699d56.jpg";